import React, { useEffect, useState } from "react";
import { Button, Icon, StringField } from "@culturehq/components";
import { Preview } from "@creatomate/preview";
import { Trans } from "app/utils";
import { useTemplateBuilder } from "components/admin/templates/context/TemplateBuilderContext";
import { Template } from "chq";

interface CopyAndPasteJsonProps {
  preview: Preview;
}

const Json: React.FC<CopyAndPasteJsonProps> = ({ preview }) => {
  const [creatomateJson, setCreatomateJson] = useState<any | null>(null);
  const [jsonError, setJsonError] = useState<string | null>(null);
  const { handleState, state, templateBuilderSelection } = useTemplateBuilder();
  const { templateId, template } = state;

  useEffect(
    () => {
      handleState({ templateId: template?.value || templateId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []
  );

  const handleCopyToClipboard = async () => {
    const jsonToCopy = preview.getSource();
    const jsonString = JSON.stringify(jsonToCopy, null, 2);
    try {
      await navigator.clipboard.writeText(jsonString);
      // eslint-disable-next-line no-alert
      alert("JSON copied to clipboard");
    } catch (err) {
      // eslint-disable-next-line no-alert
      alert("Error copying JSON to clipboard");
    }
  };

  const handleApplyJson = () => {
    if (!creatomateJson) return;
    preview.setSource(creatomateJson);
  };

  const handleTemplateIdChange = (value: string) => {
    handleState({ templateId: value });
  };

  return (
    <>
      <div className="Captions-Header__Title">
        <div className="Captions-Header__Actions">
          <h2><Trans>Json</Trans></h2>
        </div>
      </div>
      <div className="area">
        {templateBuilderSelection !== "none"
        && (
          <>
            <StringField
              className="chq-ffd-border"
              name="template_id"
              value={templateId}
              onChange={handleTemplateIdChange}
            >
              <Trans>Template Id</Trans>
            </StringField>
          </>
        )}
        <div className="area__json">
          <textarea
            className="area__textarea-json no-scrollbar"
            value={creatomateJson ? JSON.stringify(creatomateJson, null, 2) : ""}
            onChange={e => {
              const inputValue = e.target.value;
              try {
                const parsedJson = JSON.parse(inputValue);
                setCreatomateJson(parsedJson);
                setJsonError(null);
              } catch (error) {
                setJsonError("Invalid JSON format. Please check your input.");
              }
            }}
            placeholder="Paste Json here"
          />
        </div>
        {jsonError && <div className="error-message">{jsonError}</div>}
        <div className="area__copy-json">
          <Button onClick={handleCopyToClipboard}>
            <Icon icon="copy" />
            <Trans>Copy Json</Trans>
          </Button>
          <Button onClick={handleApplyJson} disabled={!creatomateJson}>
            <Icon icon="checkmark" />
            <Trans>Apply Json</Trans>
          </Button>
        </div>
      </div>
    </>
  );
};

export default Json;
